// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/assets/';

export const apiUrl = 'https://kairosinternational.in/apibackend/apis/';
export const assetsUrl = 'https://kairosinternational.in/apibackend/assets/';